<svg
  width="46"
  height="46"
  viewBox="0 0 46 46"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M22.7067 44.3143C34.4601 44.3143 43.9881 34.886 43.9881 23.2555C43.9881 11.6251 34.4601 2.19678 22.7067 2.19678C10.9533 2.19678 1.42529 11.6251 1.42529 23.2555C1.42529 34.886 10.9533 44.3143 22.7067 44.3143Z"
    fill="url(#paint0_linear_852_45096)"
  />
  <path
    d="M43.4881 23.2555C43.4881 34.6049 34.1889 43.8143 22.7067 43.8143C11.2245 43.8143 1.92529 34.6049 1.92529 23.2555C1.92529 11.9062 11.2245 2.69678 22.7067 2.69678C34.1889 2.69678 43.4881 11.9062 43.4881 23.2555Z"
    stroke="#774700"
    stroke-opacity="0.5"
  />
  <path
    opacity="0.6"
    d="M10.0678 35.1887C14.3774 35.1887 17.871 31.7316 17.871 27.4672C17.871 23.2027 14.3774 19.7456 10.0678 19.7456C5.75825 19.7456 2.26465 23.2027 2.26465 27.4672C2.26465 31.7316 5.75825 35.1887 10.0678 35.1887Z"
    fill="url(#paint1_radial_852_45096)"
  />
  <path
    opacity="0.6"
    d="M35.3376 19.7456C39.6457 19.7456 43.1408 23.2035 43.1408 27.4672C43.1408 31.7337 39.6457 35.1887 35.3376 35.1887C31.0274 35.1887 27.5344 31.7337 27.5344 27.4672C27.5344 23.2035 31.0267 19.7456 35.3376 19.7456Z"
    fill="url(#paint2_radial_852_45096)"
  />
  <path
    d="M29.0509 29.7584C25.1854 33.0295 20.2212 33.0281 16.3579 29.7584C15.811 29.2965 15.484 29.797 15.6585 30.1887C18.6265 36.8559 26.7858 36.8545 29.7517 30.1887C29.9269 29.7963 29.6013 29.2958 29.0509 29.7584Z"
    fill="#1A1626"
  />
  <path
    d="M26.062 21.5055C28.1695 19.9668 31.964 19.8643 34.2411 21.5055C34.7675 21.8845 35.6407 21.6213 35.4449 21.1791C33.4551 16.6711 26.8423 16.6809 24.8567 21.1791C24.6624 21.6213 25.5385 21.888 26.062 21.5055Z"
    fill="#1A1626"
  />
  <path
    d="M19.3454 21.5055C17.2378 19.9668 13.4433 19.8643 11.1662 21.5055C10.6399 21.8845 9.76663 21.6213 9.96242 21.1791C11.9522 16.6711 18.5651 16.6809 20.5506 21.1791C20.745 21.6213 19.8689 21.888 19.3454 21.5055Z"
    fill="#1A1626"
  />
  <path
    d="M12.3429 11.0632C4.79226 13.8717 8.99746 15.4989 15.6685 13.897C19.4346 12.9929 17.3135 9.21211 12.3429 11.0632Z"
    fill="#D69600"
  />
  <path
    d="M33.0647 11.0724C28.0933 9.22275 25.9744 13.0021 29.7398 13.9062C36.4108 15.5088 40.616 13.8809 33.0647 11.0724Z"
    fill="#D69600"
  />
  <defs>
    <linearGradient
      id="paint0_linear_852_45096"
      x1="22.7067"
      y1="44.3143"
      x2="22.7067"
      y2="2.19678"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#FF7B00" />
      <stop offset="0.3236" stop-color="#FFAE00" />
      <stop offset="0.6205" stop-color="#FFD600" />
      <stop offset="0.8558" stop-color="#FFEE00" />
      <stop offset="1" stop-color="#FFF700" />
    </linearGradient>
    <radialGradient
      id="paint1_radial_852_45096"
      cx="0"
      cy="0"
      r="1"
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(10.0682 27.4672) scale(7.80317 7.72155)"
    >
      <stop offset="0.1" stop-color="#FF6399" />
      <stop offset="0.2424" stop-color="#FF6595" stop-opacity="0.8417" />
      <stop offset="0.3901" stop-color="#FF6C88" stop-opacity="0.6777" />
      <stop offset="0.5401" stop-color="#FF7874" stop-opacity="0.511" />
      <stop offset="0.6918" stop-color="#FF8857" stop-opacity="0.3424" />
      <stop offset="0.8449" stop-color="#FF9D31" stop-opacity="0.1724" />
      <stop offset="0.997" stop-color="#FFB604" stop-opacity="0.01" />
      <stop offset="1" stop-color="#FFB703" stop-opacity="0" />
    </radialGradient>
    <radialGradient
      id="paint2_radial_852_45096"
      cx="0"
      cy="0"
      r="1"
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(35.3372 27.4672) scale(7.80317 7.72155)"
    >
      <stop offset="0.1" stop-color="#FF6399" />
      <stop offset="0.2424" stop-color="#FF6595" stop-opacity="0.8417" />
      <stop offset="0.3901" stop-color="#FF6C88" stop-opacity="0.6777" />
      <stop offset="0.5401" stop-color="#FF7874" stop-opacity="0.511" />
      <stop offset="0.6918" stop-color="#FF8857" stop-opacity="0.3424" />
      <stop offset="0.8449" stop-color="#FF9D31" stop-opacity="0.1724" />
      <stop offset="0.997" stop-color="#FFB604" stop-opacity="0.01" />
      <stop offset="1" stop-color="#FFB703" stop-opacity="0" />
    </radialGradient>
  </defs>
</svg>
